import { Link } from "react-router-dom";

export default function(){

    return(
        <Link to={'/dashboard'} className="btn-return">
                <img width={'8%'} src="./assets/back.svg" alt="Back" />
        </Link>
    )
}